import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OAuthModule } from './oauth/oauth.module';

@NgModule({
  imports: [
    CommonModule,
    OAuthModule
  ],
  exports: [
    OAuthModule
  ],
  declarations: []
})
export class AuthModule { }
